import { invalidateProjectCountsQuery } from './useFetchProjectCountsQuery';
import { invalidateProjectsQueries } from './useFetchProjectsQuery';
import { invalidateProjectIncludedFeaturesQuery } from './useFetchIncludedFeaturesQuery';

export default class ProjectsQueryInvalidator {
	static invalidateProjectListsAndCounts() {
		invalidateProjectCountsQuery();
		invalidateProjectsQueries();
	}

	static invalidateProjectIncludedFeatures() {
		invalidateProjectIncludedFeaturesQuery();
	}
}
